import config from 'config';
import { getCookie } from 'helpers';
import { APIResponse } from 'types/Request';
import { NoMatriculado } from 'types/NoMatriculados';

export async function getNoMatriculate(): Promise<NoMatriculado | undefined> {
  try {
    const url = new URL(`${ config.baseUrl }/no-matriculates`);

    type Response = APIResponse<NoMatriculado>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      return;
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok') {
      if (content.code === 'CONNECTION_ERROR') {
        return;
      }

      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar la información.');
    }

    return content.payload;
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar la información.');
  }
}
